import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { TOUR_ADVERTISING_SITE_OPTION_ITEMS } from 'common/tourConstants';

import { createInitialValues } from 'client/helpers/formikHelpers';

import { SR_CHECKBOX_THEME_BOX } from 'client/components/Checkbox';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

import ButtonDeprecated, { BUTTON_THEME_GREEN_ADOBE } from 'client/components/ButtonDeprecated';

const SrSelfShowingAdvertisingSiteModal = ({ onSubmit }) => {
  const formField = {
    id: 'advertisingSite',
    title: 'I found this listing on...',
    validations: ['required'],
    type: 'multiple_choice',
    properties: {
      multipleSelection: false,
      checkboxListClassName: 'checkboxListBoolean',
      choices: TOUR_ADVERTISING_SITE_OPTION_ITEMS,
      fieldType: SR_CHECKBOX_THEME_BOX,
      columns: 1,
      width: '100%',
      gridGap: '10px',
    },
  };

  return (
    <SrSimpleMessageModal
      message={
        <Formik
          onSubmit={onSubmit}
          initialValues={createInitialValues({
            formFields: [formField],
            defaultValues: {},
          })}
          render={(formikBag) => (
            <Form>
              <div style={{ textAlign: 'left' }}>
                <SrText display="block" font="greycliff" weight="800" size="26" lineHeight="33px">
                  Were you talking to a scammer? Take a quiz.
                </SrText>
                <SrText paddingTop="10px" display="block" font="greycliff" weight="500" size="16">
                  Beware of scammers, they copy listings onto some websites and pretend to be the
                  owner.
                </SrText>
                <SrBox paddingBottom="80px">
                  <SrFormikField
                    formikBag={formikBag}
                    formField={formField}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                </SrBox>
                <SrBox
                  width="100%"
                  height="100px"
                  textAlign="center"
                  position="fixed"
                  bottom="0"
                  left="0"
                  backgroundColor="white"
                >
                  <SrBox width="355px" margin="0 auto">
                    <ButtonDeprecated
                      type="submit"
                      theme={BUTTON_THEME_GREEN_ADOBE}
                      disabled={!formikBag.isValid}
                    >
                      Verify the site
                    </ButtonDeprecated>
                  </SrBox>
                </SrBox>
              </div>
            </Form>
          )}
        />
      }
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      maxWidth={375}
    />
  );
};

SrSelfShowingAdvertisingSiteModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

SrSelfShowingAdvertisingSiteModal.displayName = 'SrSelfShowingAdvertisingSiteModal';

export default SrSelfShowingAdvertisingSiteModal;
